import React from 'react';
import { Switch, FormControlLabel } from '@mui/material';
import { Controller } from 'react-hook-form';

const Checkout = ({ control, name, label, color, ...props }) => {
  return (
    <FormControlLabel
      control={
        <Controller
          control={control}
          name={name}
          defaultValue={props.value || false}
          render={({ field: { onChange, value } }) => (
            <Switch onChange={onChange} checked={!!value} color={color} />
          )}
        />
      }
      label={label}
      {...props}
    />
  );
};

export default Checkout;
